export function productImagePaths(product) {
  const images = product.images || [];
  return [...new Set([
    ...(product.imagePathList || []),
    ...images.filter(image => image?.sortOrder === 0),
    ...images,
    product.image,
  ].map(image => typeof image === 'string' ? image : image?.imagePath || image?.path)
    .filter(path => typeof path === 'string' && path.length > 0))];
}
